import { Component, OnInit, ViewChild } from '@angular/core';
import { RestWS } from 'app/services/restService';
import { MatPaginatorIntl, MatPaginator } from '@angular/material/paginator';



@Component({
  selector: 'app-listaclientes',
  templateUrl: './listaclientes.component.html',
  styleUrls: ['./listaclientes.component.scss']
})
export class ListaclientesComponent implements OnInit {

  dataSource:  | null;
  dataSourceTemplate:  null;

  idEvento: string;

  tieneEventos: boolean;

  loading: boolean;

  

  clientes: any = [];
  constructor( public http: RestWS) { }

  async ngOnInit() {
    let clis: any = await this.http.getEmpresas();
    if (clis.status === 'ok') {
      this.clientes = clis.message;
    }
  }

}
